import * as Yup from 'yup';

export const validationSchemaRule = Yup.object().shape({
  positionId: Yup.mixed().required('Debe seleccionar un cargo para aplicarle la regla'),
  constraints: Yup.object().shape({
    maxWeeklyHours: Yup.number()
      .typeError('Debe ser un número válido')
      .positive('Debe ser mayor a 0')
      .integer('Debe ser un número entero')
      .nullable(),
    minRestHoursBetweenShifts: Yup.number()
      .typeError('Debe ser un número válido')
      .positive('Debe ser mayor a 0')
      .nullable(),
    maxConsecutiveWorkDays: Yup.number()
      .typeError('Debe ser un número válido')
      .positive('Debe ser mayor a 0')
      .integer('Debe ser un número entero')
      .required('Este campo es obligatorio'),
  }),
});
